/**
 * Platform configuration events — operator-facing warnings and errors that are
 * not application runtime errors (e.g. a manual DNS entry overwritten by
 * gateway automation, or a rejected manual mutation on an auto-managed
 * record). Stored durably and acknowledgeable from the ops UI.
 */

export type TOpsConfigEventSeverity = 'warning' | 'error';

/** Stable seek position for descending platform-event pages. */
export interface IOpsConfigEventCursor {
  createdAt: number;
  id: string;
}

export interface IOpsConfigEventContext {
  domain?: string;
  recordName?: string;
  previousValue?: string;
  newValue?: string;
  routeRef?: string;
  actor?: string;
}

export interface IOpsConfigEvent {
  id: string;
  severity: TOpsConfigEventSeverity;
  /** Producer-defined event class, e.g. 'dns-conflict'. */
  category: string;
  /** Short human-readable summary. */
  title: string;
  /** Full explanation of what happened and why. */
  detail: string;
  context: IOpsConfigEventContext;
  createdAt: number;
  acknowledgedBy?: string;
  acknowledgedAt?: number;
}
